var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8018 12.5879C13.5632 12.5879 15.8018 10.3493 15.8018 7.58789C15.8018 4.82647 13.5632 2.58789 10.8018 2.58789C8.04033 2.58789 5.80176 4.82647 5.80176 7.58789C5.80176 10.3493 8.04033 12.5879 10.8018 12.5879Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.22278 16.9622C3.99118 15.6321 5.09607 14.5277 6.42644 13.7599C7.75681 12.9921 9.26581 12.5879 10.8019 12.5879C12.3379 12.5879 13.8469 12.9921 15.1772 13.76C16.5076 14.5278 17.6125 15.6323 18.3808 16.9623",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccess);
export default __webpack_public_path__ + "static/media/Access.56889bb92aa82b496e3adc42658beead.svg";
export { ForwardRef as ReactComponent };